import { Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../../scss/freelancing-guide-styling-components/challenge-section.style.scss";
import { useTranslation } from "react-i18next";
import { Challenges } from "../../constant/challenges-section.constant";
import { ChallengesHeroImage } from "../images/png/icons";

export const ChallengeSection = () => {
  const { t } = useTranslation();
  const BOOTSTRAP_MD_BREAKPOINT = 768;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
  const isMobile = window.innerWidth < 576;

  useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= BOOTSTRAP_MD_BREAKPOINT);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container className="challenge-section-container padding-140-challenge-section">
      <Row className={`challenge-section-row align-items-center ${isLargeScreen ? "large-screen" : ""}`}>
        {!isMobile && (
          <Col md={6} className="d-flex justify-content-center align-items-center px-0">
            <img src={ChallengesHeroImage} alt={t("CHALLENGES_SECTION_TITLE")} className="challenge-section-image" />
          </Col>
        )}
        <Col md={6} className="challenge-section-content-col px-0 half-stretch-content ">
          <div className={`challenge-section-content${isLargeScreen ? " large" : ""}`}>
            {isMobile && <img src={ChallengesHeroImage} alt={t("CHALLENGES_SECTION_TITLE")} className="challenge-section-image" />}
            <h2 className="challenge-section-title">{t("CHALLENGES_SECTION_TITLE")}</h2>
            <div style={{ height: "2rem" }} />
            <p className="challenge-section-description">{t("CHALLENGES_SECTION_DESC")}</p>
            <div style={{ height: "3rem" }} />
            <Row>
              {Challenges.map(({ icon, title, description }, idx) => (
                <Col md={10} key={idx} className="challenge-section-feature-col">
                  <div>
                    <div className="challenge-section-feature-row">
                      <div className="challenge-section-feature-icon">
                        <img src={icon} alt={t(title)} />
                      </div>
                      <div className="challenge-section-feature-title-wrap">
                        <h3 className="challenge-section-feature-title">{t(title)}</h3>
                      </div>
                    </div>
                    <p className="challenge-section-feature-description">{t(description)}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
